import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { BRAND } from '../lib/brand';
import { covers } from '../lib/api';

const testIds = ['tile-my-athletes', 'tile-eval-setup', 'tile-drill-setup', 'tile-trainer-passport'];
const descriptions = ['Baseball hitter at practice', 'Pitcher developing his delivery', 'Athlete preparing for batting practice', 'Baseball player following through'];
const categories = ['PLAYER DEVELOPMENT', 'THE EVALUATION SERIES', 'BUILT IN THE REPS', ''];

export const CommandTile = ({ tile, index, count, isPublic }) => {
  const { path, title, sub, icon: Icon, number, className, word } = tile;
  return (
    <Link to={path} className="album-item" data-testid={testIds[index]}>
      <div className={`album-cover ${className}`}>
        <img src={covers[index]} alt={descriptions[index]} />
        <div className="cover-shade" />
        <div className="cover-top"><span className="cover-category">{categories[index]}</span><span className="cover-number">{number}</span></div>
        <div className="cover-type">{word.split('\n').map((line, j) => <span key={j}>{line}</span>)}</div>
        <div className="cover-bottom">
          <span className="cover-symbol"><Icon size={21} /></span>
          <span className="cover-brand shc-cover-brand" data-testid={`command-tile-brand-${index}`}>{BRAND.name.toUpperCase()}</span>
          <span className="cover-arrow"><ArrowUpRight size={22} /></span>
        </div>
      </div>
      <div className="album-label"><h3>{title}</h3><ArrowUpRight size={17} /></div>
      <p>{sub}</p>
      <span className="album-count"><i className={index === 3 && !isPublic ? 'private-dot' : ''} />{count}</span>
    </Link>
  );
};